import React from "react";
import "../styles/Pmjjby.css";
import PmjjbyBanner from "../assets/photos/pmjjby-banner.png";

function Pmjjby() {
  return (
    <div className="pmjjby-wrapper">

      {/* HERO */}

      <section className="pmjjby-hero">
        <h1>Pradhan Mantri Jeevan Jyoti Bima Yojana</h1>
        <p>
          Government backed life insurance scheme providing financial
          protection to families in case of death of the insured person.
        </p>

        <div className="pmjjby-badge">
          Government Social Security Insurance Scheme
        </div>
      </section>


      {/* SCHEME INFO */}

      <section className="pmjjby-info">

        <div className="info-card">
          <h3>Entry Age</h3>
          <p>18 – 50 Years</p>
        </div>

        <div className="info-card">
          <h3>Coverage Age</h3>
          <p>Up to 55 Years</p>
        </div>

        <div className="info-card">
          <h3>Annual Premium</h3>
          <p>₹436 per year</p>
        </div>

        <div className="info-card">
          <h3>Sum Assured</h3>
          <p>₹2,00,000</p>
        </div>

      </section>



      {/* ABOUT */}

      <section className="pmjjby-about">

      <a href="https://financialservices.gov.in/beta/en/pmjjby"><img src={PmjjbyBanner} alt="info-pm-jeevan"/></a>
                      <h6>Click the Banner to Know more.</h6>

        <h2>About the Scheme</h2>
        <p>
          Pradhan Mantri Jeevan Jyoti Bima Yojana (PMJJBY) is a government
          supported life insurance scheme providing life cover for death
          due to any reason.
        </p>

        <p>
          The scheme is offered through banks and implemented by life
          insurance companies to ensure affordable protection for citizens.
        </p>

        <div className="about-grid">

          <div className="about-box">
            <h4>Plan Type</h4>
            <p>Term Life Insurance</p>
          </div>

          <div className="about-box">
            <h4>Insurance Partner</h4>
            <p>Life Insurance Corporation of India</p>
          </div>

          <div className="about-box">
            <h4>Policy Tenure</h4>
            <p>1 Year (Renewable)</p>
          </div>

        </div>

      </section>


      {/* ELIGIBILITY */}

      <section className="pmjjby-eligibility">

        <h2>Eligibility Criteria</h2>

        <div className="eligibility-grid">

          <div className="eligibility-card">
            <h3>Age</h3>
            <p>18 to 50 years</p>
          </div>

          <div className="eligibility-card">
            <h3>Bank Account</h3>
            <p>Must have a Savings Bank Account</p>
          </div>

          <div className="eligibility-card">
            <h3>Auto Debit</h3>
            <p>Premium auto-debited annually</p>
          </div>

        </div>

      </section>

      {/* BENEFIT BANNER */}

            <section className="pmjjby-benefit">

              <h2>Life Insurance Protection</h2>

              <div className="benefit-highlight">

                <h3>₹2,00,000 Life Cover</h3>

                <p>
                  In case of death of the insured person due to any reason,
                  the nominee receives the insurance amount.
                </p>

              </div>

            </section>



      {/* POLICY TIMELINE */}

      <section className="pmjjby-timeline">

        <h2>Policy Coverage Period</h2>

        <div className="timeline-container">

          <div className="timeline-item">
            <div className="circle"></div>
            <div className="timeline-content">
              <h4>1 June</h4>
              <p>Policy Start</p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="circle"></div>
            <div className="timeline-content">
              <h4>31 May</h4>
              <p>Policy End</p>
            </div>
          </div>

        </div>

      </section>



      {/* PREMIUM */}

      <section className="pmjjby-premium">

        <h2>Premium Details</h2>

        <div className="premium-box">

          <h3>₹436 Per Year</h3>

          <p>
            The premium amount will be automatically deducted from
            the subscriber's savings account every year.
          </p>

        </div>

      </section>



      {/* CLAIM */}

      <section className="pmjjby-claim">

        <h2>Claim Procedure</h2>

        <div className="claim-grid">

          <div className="claim-card">
            <h3>Step 1</h3>
            <p>Nominee informs the bank branch.</p>
          </div>

          <div className="claim-card">
            <h3>Step 2</h3>
            <p>Submit claim form and documents.</p>
          </div>

          <div className="claim-card">
            <h3>Step 3</h3>
            <p>Bank forwards claim to insurance company.</p>
          </div>

          <div className="claim-card">
            <h3>Step 4</h3>
            <p>Insurance company processes settlement.</p>
          </div>

        </div>

      </section>



      {/* FAQ */}

      <section className="pmjjby-faq">

        <h2>Frequently Asked Questions</h2>

        <div className="faq-box">
          <h4>Who can enroll in PMJJBY?</h4>
          <p>Any individual between 18 and 50 years having a savings account.</p>
        </div>

        <div className="faq-box">
          <h4>What is the coverage amount?</h4>
          <p>The scheme provides life cover of ₹2,00,000.</p>
        </div>

        <div className="faq-box">
          <h4>What is the premium amount?</h4>
          <p>The premium is ₹436 per year.</p>
        </div>

      </section>



      {/* DOWNLOAD */}

      <section className="pmjjby-download">

        <a href="/forms/pmjjby-form.pdf" className="pmjjby-btn">
          Download Form
        </a>

      </section>

    </div>
  );
}

export default Pmjjby;